import CONQUER from "../CONQUER";
import * as Colyseus from "colyseus.js";
import CONFIG from "../../Core/CONFIG/CONFIG";
import { EventDispatcher } from 'EventDispatcher';
import { ACTIONS } from "../../Models/ENUM";

export default class ColyseusClient {
    private conquer: CONQUER;
    private client: Colyseus.Client;
    private room: Colyseus.Room | undefined;
    private ed: EventDispatcher;
    private static messageType: string = 'ACTION';
    private static roomType: string = 'room_type';
    private static myEventTypes = ['action'];

    constructor ( conquer: CONQUER ) {
        this.conquer = conquer;
        this.ed = new EventDispatcher ({ validEventTypes: ColyseusClient.myEventTypes });
        console.log('constructor');
        this.client = new Colyseus.Client( CONFIG.vars.PUBLIC_COLYSEUS_FULL_URL );
        console.log('client');
    }

    public async init() {
        let self = this;
        await new Promise<void>(resolve => {
            self.client.create( ColyseusClient.roomType ).then( ( tmpRoom ) => {
                console.log('create');
                self.room = tmpRoom;
                self.room.onMessage( ColyseusClient.messageType, (message) => {
                    self.onMessage(message);
                } );
                console.log( self.room.sessionId, "joined", self.room.name );
                resolve();
            } ).catch( e => {
                console.log( "JOIN ERROR", e );
                resolve();
            } );
        });
    }

    private onMessage ( message: any ) {
        // console.log('message',message)
        this.ed.trigger('action', message);
    }

    public async do<T>(action:ACTIONS, data?:T) {
        let self = this;
        return new Promise( resolve => 
            {
                self.ed.one('action', (message) => {
                    // purify message by removing 'type'
                    let output = {};
                    Object.assign(output, message);
                    delete (output as any).type;
                    resolve(output);
                });
                self.room!.send(ColyseusClient.messageType, {
                    action:action,
                    data: data
                });
            }
         ); 
        
    }

}